// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const PauseOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 6 8","focusable":"false"},"children":[{"tag":"g","attrs":{"fill":"currentColor"},"children":[{"tag":"rect","attrs":{"height":"8","rx":"1","width":"2"}},{"tag":"rect","attrs":{"height":"8","rx":"1","width":"2","x":"4"}}]}]},"name":"pause","theme":"outlined"};

const PauseOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={PauseOutlinedSvg} />;
  PauseOutlined.displayName = 'PauseOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(PauseOutlined);
